
export default{
    packing:[ 
        {
            key : 'džak 50kg',
            sr : 'džak 50kg',
            en : 'sack 50kg',
        },
        {
            key : 'rinfuz',
            sr : 'rinfuz',
            en : 'in bulk',
        },
        {
            key : 'džak 33kg',
            sr : 'džak 33kg',
            en : 'sack 33kg',
        }
    ]
}
